

var allVariants;
jQuery.getJSON(mainUrl, function(product) {
  allVariants = product.variants;
}); 

$('select.sizeSelectionSelect').on('change', function() {
    $(this).addClass('valueSaved'); //Get the choosen value
});

function updateSelections()
  {
    var allItems = document.querySelectorAll('select.sizeSelectionSelect');
    for(var i = 0;i < allItems.length; i++)
    {
      
      var allOptionsInside = allItems[i].querySelectorAll('*');
      var matchedColor = allItems[i].getAttribute('color-name');

      if(!allItems[i].classList.contains('selectedHere') && !allItems[i].classList.contains('valueSaved'))
      {
      if(allOptionsInside.length > 0 && matchedColor)
      {
        
      for(var j = 0;j < allOptionsInside.length; j++)
      {
        if(allOptionsInside[j])
        {
        //allOptionsInside[j].style.display="none"; 

        //allOptionsInside[j].setAttribute('hidden',true);

        var nodeA = allOptionsInside[j];
 
        // now show only ones with color
       // console.log(allOptionsInside[j].className + ' - '+matchedColor);
        if(allOptionsInside[j].className == matchedColor)
        {
           //allOptionsInside[j].style.display="block";
          //allOptionsInside[j].removeAttribute('hidden');
 
        var elemA = document.createElement('option');
        elemA.innerHTML = nodeA.innerHTML;
        elemA.className = allOptionsInside[j].className;
        if(allOptionsInside[j].textContent.includes('Udsolgt'))
        {
          elemA.setAttribute('disabled','true');
        }
        nodeA.parentNode.replaceChild(elemA, nodeA);
          
        }else{
          
        var elemA = document.createElement('div');
        elemA.innerHTML = nodeA.innerHTML;
        elemA.className = allOptionsInside[j].className;
        nodeA.parentNode.replaceChild(elemA, nodeA);
          
        }
           
        } 
      }

       // first element to disabled
        var firstOption = allItems[i].querySelector('.firstOption');
        var elemAa = document.createElement('option');
        elemAa.innerHTML = firstOption.innerHTML;
        elemAa.className = firstOption.className;  
       // elemAa.setAttribute('disabled','true'); 
        firstOption.parentNode.replaceChild(elemAa, firstOption);

      if(!allItems[i].classList.contains('valueSaved'))
      {
         allItems[i].selectedIndex = 0;
      }
        
      }
      }    
 
    }
  }

function updateFinalVariants()
  {  
    var array = document.querySelectorAll('input.hidden-color'); 
    var allAvailable = true;
    for (var i = 0; i < array.length; i++){
    var index = i + 1; 
    var finalVariantValue = 0;var availableVar = true;var buildVariant;
    var selectMainWrap = $('.color-selection__grid-item[data-count="'+index+'"]');
    if(selectMainWrap.length>0)
    {
      buildVariant = array[i].getAttribute('variant-id') + ' / ' + selectMainWrap.find('select.sizeSelectionSelect').val();

      console.log(buildVariant);
      
        for (var j = 0; j < allVariants.length; j++){
          if(allVariants[j].title == buildVariant)
          {
            finalVariantValue = allVariants[j].id;
            availableVar = allVariants[j].available;
          }
        } 
    }

  array[i].setAttribute('variant-id-final',finalVariantValue);
  allAvailable = availableVar;
      
  if(!availableVar)
  { 
    alert(buildVariant + ' er ikke tilgængelig');
    var itemError = document.querySelector('.color-selection__grid.more-colors-grid.mainGridHere .color-selection__grid-item:nth-child('+index+')');
    itemError.classList.add('errorHere');
    setTimeout(function(){
      itemError.classList.remove('errorHere');
    },10000);
   break;
  }
      
  }
    return allAvailable;
  }

function setProgressBar(total, filled) {
    const progressBarFill = document.querySelector('.progress-bar-fill');
    const percentage = (filled / total) * 100;
    progressBarFill.style.width = `${percentage}%`;


  $('.color-selection__selection-container .color-selection__grid .color-selection__image').removeClass('bk-border');
  $('.color-selection__selection-container .color-selection__grid .color-selection__image:not(.coladded)').first().addClass('bk-border');

}
 


function updateProgress(){
   
      
        var totalFilledColor = $('.hidden-color[value!=""]').length;
      var totalToBeFilled = parseInt($('#pick-color-id').attr('custom-toshow'));
            setProgressBar(totalToBeFilled,totalFilledColor);

      $('.greyedText .selectedColor').text(totalFilledColor);


      
      if (totalFilledColor == totalToBeFilled) {
     
       $('.hidden-overlay').click();
        $('#AddToCart').removeAttr('disabled');
        $('.remover_upsell').removeAttr('disabled');
       
        $('.template-product-nailkit').addClass('allfill');
        $('.custom-fixed-footer button').removeAttr('disabled');
        $('#StickyAddToCart').removeClass('disabled');
        $('#StickyAddToCart .loader-button__text').text(window.translationsText.stickyFilled); 
      }   else{

 $('#StickyAddToCart').addClass('disabled');
        $('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());
                $('.template-product-nailkit').removeClass('allfill');
      setTimeout(function(){
      $('#AddToCart').attr('disabled','true');
        $('.custom-fixed-footer button').attr('disabled','true');
        
     },100);
    
    }

  updateSelections();
}

$(document).ready(function(){
  
  $('.color-selection__image--top').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var count = $(this).closest('.color-selection__grid-item').data('count');
    


    
    if($(this).closest('.color-selection__grid-item').hasClass('active')){
      $('.color-selection__grid-item.active').removeClass('active');
      $('.color-selection__selection-container').hide();
	
      $('body').removeClass('color-choose-active');
   
    }
    else{
    $('.color-selection__grid-item.active').removeClass('active');
    $(this).closest('.color-selection__grid-item').addClass('active');
    $(`.color-selection__selection-container`).css('display', 'flex');
      
      $('body').addClass('color-choose-active');
      
    }
    

    
  });
  
  
  $('.color-selection__selection-grid-item.clickable').click(function(event) { 
    if($(this).data('disable') == undefined){

      $('.color-selection__selection-grid-item.clickable').attr('data-disable',true);
      var $file = $(this).children('.color-selection__image').data('file');
      var $colorName = $(this).children('.color-selection__image').data('name');
        var $variantId = $(this).children('.color-selection__image').data('variant');
      var $comp = $(this).children('.color-selection__image').data('comp');

      //lets find first unselected index instead


      var count = $('.hidden-color[value=""]:eq(0)').data('color-index'); //$(this).parent('.color-selection__selection-container').data('count');

      
      var totalCount = $('.color-selection__grid-item').data('total-count');


      var $input = $(`#color${count}`);


      
      var $img = $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top');
      var $selectionVAl = $(`.color-selection__grid-item[data-count=${count}]`).find('select.sizeSelectionSelect');
      var $title = $(`.color-selection__grid-item[data-count=${count}]`).find('.farbe-title');
      $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top').find('.color-selection-ad-text').remove();


      
            $input.val($colorName);
            $input.attr('variant-id',$variantId);
            $input.attr('variant-img',$file);
            $input.attr('comp',$comp);

      
      
      $img.css('backgroundImage', `url(${$file})`);
      $title.text($colorName);
      //  $img.css('backgroundColor', '#fff');
      $img.addClass('coladded');

      $selectionVAl.attr('color-name',$colorName.replace(' ',''));

      //console.log($selectionVAl.find("option:first").val());
      //$selectionVAl.val($selectionVAl.find("option:first").val());
      setTimeout(function(){
        $selectionVAl.val($selectionVAl.find("option:first").val());
      },50);
 
      
      updateProgress();
      
      setTimeout(function(){
      $('.color-selection__selection-grid-item.clickable').removeAttr('data-disable');},50);
      
    }else{
      event.stopPropagation();
    }
  });
  

  
  $('#StickyAddToCart').click(function(ev){
ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();


    $('html, body').animate({
    scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
 }, 750);


    setTimeout(function(){$('#MainPaymentContainer').trigger('click')},650);
          //if($(this).hasClass('disabled')){  }
  });
  


  
  $('body').on('click','#MainPaymentContainer',function(evt){
    if($(this).find('#AddToCart').attr('disabled') == 'disabled'){ 

      evt.preventDefault();
      evt.stopImmediatePropagation();
      $('.color-selection__image.color-selection__image--top.pi-1').trigger('click');

};


});
  $('.color-choose-filter').click(function(evt){

    evt.preventDefault();
    evt.stopImmediatePropagation();
$(this).parents('.color-selection__selection-container').find('.color-choose-filter').removeClass('text--underlined');
$(this).addClass('text--underlined');


let offSet = ($(this)[0].offsetLeft);
   // $('.color-filter-link-bar .link-bar__scroller').scrollLeft(offSet);

   $('.color-filter-link-bar .link-bar__scroller').animate({
        scrollLeft: ($(this).position().left + $('.color-filter-link-bar .link-bar__scroller').scrollLeft()) - 100 
    }, 500);

    
    var filterVal = $(this).data('tag');

       $(this).parents('.color-selection__selection-container').find('.color-selection__selection-grid-item.clickable').hide().filter('.' + filterVal).show();
    
    
    
  });


  $('body').on('click','.custom-new-upsell',function(evt){
    if($(this).find('.remover_upsell').attr('disabled') == 'disabled'){ 

      evt.preventDefault();
      evt.stopImmediatePropagation();
      $('.color-selection__image.color-selection__image--top.pi-1').trigger('click');
    }
  });

  $('.color-selection__arrow.close_icon_svg').click(function(evt){
    evt.preventDefault();evt.stopImmediatePropagation();



      var $parent = $(this).parents('.color-selection__grid-item');

      //lets find first unselected index instead


      var count = $parent.data('count');

      
      var totalCount = $('.color-selection__grid-item').data('total-count');


      var $input = $(`#color${count}`);


      
      var $img = $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top');

          $(`.color-selection__grid-item[data-count=${count}]`).find('.farbe-title').text(`${window.translationsText.farbe} ${count}`);


        $input.val('');
        $input.removeAttr('variant-id');
        $input.removeAttr('comp');
        $input.removeAttr('variant-img');
        $img.removeAttr('style');
        $img.removeClass('coladded');


        var $selectItem = $parent.find('select.sizeSelectionSelect');
        $selectItem.removeClass('selectedHere').removeClass('valueSaved');      

    
        updateProgress();
     
  });



      
  document.addEventListener('variant:changed', function(event) {

    updateProgress();

  });
  
  $("body").click(function(event){
    if(!$(event.target).is('.color-selection__selection-container')&&!$(event.target).is('.color-selection__selection-grid-item')&&!$(event.target).is('.color-selection__selection-grid-item *')&&!$(event.target).is('.link-bar .container')&&!$(event.target).is('.link-bar')&&!$(event.target).is('.link-bar__linklist')&&!$(event.target).is('.link-bar__scroller')&&!$(event.target).is('.link-bar__link-item')&& !$(event.target).is('.color-choose-filter')&&!$(event.target).is('.color-selection__image--top') &&!$(event.target).is('#MainPaymentContainer .disabled-text') &&!$(event.target).is('#MainPaymentContainer #AddToCart')  && !$(event.target).is('.color-selection-pi-text') && !$(event.target).is('.color-tool-tip')&& !$(event.target).is('.changeSelectionImage')&& !$(event.target).is('img.smallSelectionImage') ){
      $('.color-selection__grid-item.active').removeClass('active');
      $('.color-selection__selection-container').hide();
    $('body').removeClass('color-choose-active');
    }
  })
  


  setProgressBar(parseInt($('#pick-color-id').attr('custom-toshow')),$('.hidden-color[value!=""]').length);
   $('#AddToCart').attr('disabled','true');
  $('#StickyAddToCart').addClass('disabled');
  //$('#AddToCart').append(`<span class='disabled-text'>${window.translationsText.buttonUnfilled}</span>`);
        $('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());

  
});



function buyBundle()
{


var allSizesFilled = true;
var allItems = document.querySelectorAll('select.sizeSelectionSelect');
for(var i = 0;i < allItems.length; i++)
{ 
  var currentItem = allItems[i];
  if(currentItem.value == 'select' || currentItem.value == 'Vælg størrelse')
  {
    allSizesFilled = false;
    currentItem.classList.add('errorHere'); 
     setTimeout(function(){
       $('select.sizeSelectionSelect').removeClass('errorHere');  
       console.log('removed border')
     }, 3000);
  }   
}
if(!allSizesFilled)
{ 
    $("html, body").animate({ scrollTop: $('div#pick-color-id').position().top }, "slow");
 
  return;
}

  
  
// set all variant ids from option names
var returnValue = updateFinalVariants();

if(!returnValue)
{
  console.log('not all available');
  return;
}
  
var items = []; 
var array = document.querySelectorAll('input.hidden-color'); 
for (var i = 0; i < array.length; i++){
 
var value = parseInt(array[i].getAttribute('variant-id-final'));
   
var item = {
quantity:1,
id:value 
}

var checkQty = true;
for (var j = 0; j < items.length; j++){
if(items[j].id == value)
{
items[j].quantity = items[j].quantity + 1;
checkQty = false; 
}
}
  
if(checkQty)
{
items.push(item); 
}
  
}

// add main product
   
console.log(items);

 
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {items},
dataType: 'json', 
success: function (data) { 
location.href="/cart";
 },
error: function()
  {
alert("Prøv igen.")
  }
 }); 
 

  
}




function changeImageSelection(index)
  {
    if(document.querySelector('.product-form.test.newBundle')){
    document.querySelector('.product-form.test.newBundle').dataset.selectionimage = index;

      $('img.smallSelectionImage').removeClass('active');
      $('img.smallSelectionImage.img'+index).addClass('active');
    }
  }



